import { Alert, Flex, SegmentedControl, Text } from '@mantine/core';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

import Loader from '@/components/ui/Loader';
import { NoteSourceFilter } from '@/entities/Notes';
import { useSidebarNoteStore } from '@/stores/local/sidebar/SidebarNoteStore';

import Actions from '../Actions';
import NoteItem from '../NoteItem';

import s from './NotesList.module.scss';

const NotesList: React.FC = () => {
  const { notes } = useSidebarNoteStore();
  const items = notes.filteredItems;

  const handleFilterChange = React.useCallback(
    (value: string) => {
      notes.setSourceFilter(value as NoteSourceFilter);
    },
    [notes],
  );

  const hasFilteredNotes = notes.hasFilteredNotes;
  const isFilterActive = notes.isFilterActive;

  return (
    <Flex className={s.root} gap="xs" direction="column">
      <div className={s.root__filters}>
        <Text size="xs" c="dimmed">
          Фильтр по источнику
        </Text>
        <SegmentedControl
          size="xs"
          value={notes.sourceFilter}
          onChange={handleFilterChange}
          data={[
            { value: 'all', label: 'Все' },
            { value: 'document', label: 'Документы' },
            { value: 'analysis', label: 'Анализы' },
            { value: 'news', label: 'Новости' },
            { value: 'manual', label: 'Общие' },
          ]}
        />
      </div>
      {notes.meta.isLoading && !notes.meta.isStaleLoaded ? (
        <Loader gap={0} fullHeight type="dots" size="md" text="Ищу заметки..." />
      ) : null}
      {notes.meta.isError ? (
        <Alert className={s.root__alert} ml="lg" mr="lg" color="red">
          Не удалось загрузить заметки
        </Alert>
      ) : null}
      {notes.meta.isStaleLoaded && !hasFilteredNotes && !notes.meta.isError ? (
        <Alert className={s.root__alert} ml="lg" mr="lg">
          {isFilterActive ? 'Нет заметок по выбранному фильтру' : 'Нет ни одной заметки'}
        </Alert>
      ) : null}
      {notes.meta.isStaleLoaded && !notes.meta.isError
        ? items.map((note) => <NoteItem actionSlot={<Actions model={note} />} key={note.id} model={note} />)
        : null}
    </Flex>
  );
};

export default observer(NotesList);
